import { useParentPostMessage } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { isEmbedded } from 'shared/utils/iframe'
import { Metadata } from 'token/shared/types'

const useGateway = () => {
  const navigate = useNavigate()
  const { postMessage } = useParentPostMessage()

  const navigateToForwardURL = useCallback(
    (metadata?: Metadata) => {
      if (!metadata?.last_node_is_gateway || !metadata?.forward_url) return

      if (isEmbedded()) {
        postMessage({
          type: 'redirect',
          url: metadata.forward_url
        })

        return
      }

      if (/^https?:\/\//.test(metadata.forward_url)) {
        window.location.href = metadata.forward_url
      } else {
        navigate(metadata.forward_url)
      }
    },
    [navigate]
  )

  return { navigateToForwardURL }
}

export default useGateway
